// extracted by mini-css-extract-plugin
export default {"bolded":"style--bolded--240526","subHeader":"style--subHeader--457e26"};